import InfoIcon from 'widget/components/InfoButton/primitives/InfoIcon';
import StyledInfoButton from 'widget/components/InfoButton/primitives/StyledInfoButton';

type Props = {
  onClick: () => void;
  sizeToHide: string;
};

export default function InfoButton({ onClick, sizeToHide }: Props) {
  return (
    <StyledInfoButton
      aria-label="Information"
      data-test="info-button"
      onClick={onClick}
      sizeToHide={sizeToHide}
      type="button"
    >
      <InfoIcon />
    </StyledInfoButton>
  );
}
